import { getCommandRequestData } from '@helpers'
import { CommandParameterDTO, ExecuteCommandBody } from '@types'

import { PrintFormCommandConfig } from '../types'

type BuiltCommandRequestData = {
  params?: Record<string, string | number | string[]>
  body?: ExecuteCommandBody
}

const getSafeConfigParams = (items?: CommandParameterDTO[]): CommandParameterDTO[] => {
  return (items ?? []).filter(item => item.title?.trim())
}

export const buildCommandRequestData = (
  command: PrintFormCommandConfig
): BuiltCommandRequestData => {
  const compiledParams = getCommandRequestData(getSafeConfigParams(command.params), null)
  const compiledBody = getCommandRequestData(getSafeConfigParams(command.body), null)

  return {
    params: Object.keys(compiledParams).length ? compiledParams : undefined,
    body: Object.keys(compiledBody).length ? (compiledBody as ExecuteCommandBody) : undefined,
  }
}
